import React, { useState } from "react";

const AuthenContext = React.createContext({
    isSuperAdmin: false,
    token: "",
    refreshToken: "",
    login: (token, refreshToken) => { },
    logout: () => { },
    resetpwd: (value) => { },
});

const calculateRemainingTime = (expirationTime) => {
    const currentTime = new Date().getTime();
    const adjExpirationTime = new Date(expirationTime).getTime();
    const remainingDuration = adjExpirationTime - currentTime;
    return remainingDuration;
};

export const AuthContextProvider = (props) => {
    const initialToken = localStorage.getItem("token");
    const initialRefreshToken = localStorage.getItem("refreshToken");
    const initialUserData = localStorage.getItem("userData");
    const [token, setToken] = useState(initialToken);
    const [userData, setUserData] = useState(initialUserData);
    const [refreshToken, setRefreshToken] = useState(initialRefreshToken);
    const [verifyOtp, setVerifyOtp] = useState(false)


    const userIsLoggedIn = !!token;
    const [isSuperAdmin, setIsSuperAdmin] = useState(localStorage.getItem("isSuperAdmin") || false);
    const verifyOtphandler = () => {
        setVerifyOtp(true)
    }

    const logoutHandler = () => {
        setToken(null);
        setRefreshToken(null);
        localStorage.removeItem('token');
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("isSuperAdmin");
        localStorage.removeItem("userData");
        setIsSuperAdmin(false);
    }

    const loginHandler = (token, userdata, refreshToken, isSuperAdmin, expirationTime) => {
        setToken(token);
        setUserData(userdata)
        setRefreshToken(refreshToken);
        localStorage.setItem("token", token);
        localStorage.setItem("userData", userdata);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("isSuperAdmin", isSuperAdmin);
        setIsSuperAdmin(isSuperAdmin);
        localStorage.setItem('expirationTime', expirationTime);
        const remainingTime = calculateRemainingTime(expirationTime);
        // setTimeout(logoutHandler, remainingTime)  // only uncomment this for logout
    }

    const contextValue = {
        token: token,
        refreshToken: refreshToken,
        isLoggedIn: userIsLoggedIn,
        isSuperAdmin: isSuperAdmin,
        login: loginHandler,
        logout: logoutHandler,
        resetpwd: verifyOtphandler,
        verifyOtp: verifyOtp
    }

    return (
        <AuthenContext.Provider value={contextValue}>
            {props.children}
        </AuthenContext.Provider>
    )

}

export default AuthenContext;